import React from 'react';

import { DashboardWidgetType, WidgetItemType } from './Dashboard.types';
import DashboardWidgetBarChartGroup from './widgets/DashboardWidgetBarChartGroup';
import DashboardWidgetCameras from './widgets/DashboardWidgetCameras';
import DashboardWidgetDriverTerminal from './widgets/DashboardWidgetDriverTerminal';
import DashboardWidgetLineChart from './widgets/DashboardWidgetLineChart';
import DashboardWidgetOnlineWeighing from './widgets/DashboardWidgetOnlineWeighing';
import DashboardWidgetProgress from './widgets/DashboardWidgetProgress';
import DashboardWidgetProgressHalf from './widgets/DashboardWidgetProgressHalf';
export type WidgetComponentProps =
 | { widgetContent: WidgetItemType[]; totalSum: number }
 | { widget: DashboardWidgetType }
 | Record<string, never>;

export interface WidgetTypeConfig {
 name: string;
 component: React.ComponentType<WidgetComponentProps>;
 requiresData?: boolean;
}

const widgetTypes: WidgetTypeConfig[] = [
 {
  name: 'driversProgress',
  component:
   DashboardWidgetProgress as React.ComponentType<WidgetComponentProps>,
  requiresData: true,
 },
 {
  name: 'destPointNeto',
  component:
   DashboardWidgetBarChartGroup as React.ComponentType<WidgetComponentProps>,
  requiresData: true,
 },
 {
  name: 'InOutProduct',
  component:
   DashboardWidgetLineChart as React.ComponentType<WidgetComponentProps>,
  requiresData: true,
 },
 {
  name: 'ProductStock',
  component:
   DashboardWidgetProgressHalf as React.ComponentType<WidgetComponentProps>,
  requiresData: true,
 },
 {
  name: 'onlineWeighing',
  component:
   DashboardWidgetOnlineWeighing as React.ComponentType<WidgetComponentProps>,
  requiresData: false,
 },
 {
  name: 'cameras',
  component:
   DashboardWidgetCameras as React.ComponentType<WidgetComponentProps>,
  requiresData: false,
 },
 {
  name: 'driverTerminal',
  component:
   DashboardWidgetDriverTerminal as React.ComponentType<WidgetComponentProps>,
  requiresData: false,
 },
];

export const getWidgetType = (name: string): WidgetTypeConfig | undefined =>
 widgetTypes.find((type) => type.name === name);

export default widgetTypes;

